import { useSelector } from 'react-redux';

import { StateType } from '../../reducers';
import { updateCustomPreferencesState } from '../../reducers/CustomPreferencesReducer/CustomPreferencesReducer';
import { getIsLoggedInSelector } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { useI18nContext } from '../services/i18n';
import { useAppDispatch } from '../services/store/useAppDispatch';

// Single entry point for every language change in the app
export const useChangeLanguage = () => {
  const dispatch = useAppDispatch();
  const i18nContext = useI18nContext();
  const isLoggedIn = useSelector((state: StateType) => getIsLoggedInSelector(state));

  return async (language: string, reload: boolean = true) => {
    if (isLoggedIn) {
      // Persist first so a failed save doesn't diverge from the account, then apply locally.
      await dispatch(updateCustomPreferencesState({ language }));
    }
    i18nContext.setLanguage(language, reload);
  };
};
